import { render, staticRenderFns } from "./UPhoneInput.vue?vue&type=template&id=15852c4a&"
import script from "./UPhoneInput.vue?vue&type=script&lang=js&"
export * from "./UPhoneInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports